import { render, staticRenderFns } from "./navmenu.vue?vue&type=template&id=1def0b2d&"
import script from "./navmenu.js?vue&type=script&lang=js&"
export * from "./navmenu.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\EmployeePortalUpdated\\Frontend\\EmployeePortal.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1def0b2d')) {
      api.createRecord('1def0b2d', component.options)
    } else {
      api.reload('1def0b2d', component.options)
    }
    module.hot.accept("./navmenu.vue?vue&type=template&id=1def0b2d&", function () {
      api.rerender('1def0b2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/shared/navmenu/navmenu.vue"
export default component.exports